import { render, staticRenderFns } from "./PersonalChat.vue?vue&type=template&id=147be7f7&scoped=true"
import script from "./PersonalChat.vue?vue&type=script&lang=ts"
export * from "./PersonalChat.vue?vue&type=script&lang=ts"
import style0 from "./PersonalChat.vue?vue&type=style&index=0&id=147be7f7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147be7f7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VAvatar,VList,VListItem,VListItemContent,VListItemSubtitle,VListItemTitle})
